import React from 'react'
import Icon from 'react-fa'

const TaskDetailsLoadingIndicator = props => {
  return (
    <div className='task-modal__loading-indicator'>
      <Icon name='spinner' pulse size='3x' fixedWidth />
    </div>
  )
}

export default TaskDetailsLoadingIndicator



// WEBPACK FOOTER //
// ./src/components/TaskDetails/TaskDetailsLoadingIndicator.js